import React from 'react';

export default function Blocker({clazzes}) {
    return (
        <div className={clazzes}>
            <div className="alpi__cell-aspect-ratio"></div>
        </div>
    );
}
